import { t } from 'i18next';

import { ProgressBarText } from '@/types/types';

export const getProgressBarText = ({
  isReports = false,
  completedStepCount = null,
  isComplete,
  timeSpentOnPlan,
  isCompliance = false,
  percentComplete,
  stepCount = null,
}: ProgressBarText) => {
  if (isReports && isComplete) {
    return t('Generic.plansCompleted');
  } else if (isReports && !timeSpentOnPlan && !isCompliance) {
    return stepCount
      ? `${completedStepCount}/${stepCount} ${t('Generic.plansCompleted')}`
      : t('Generic.noPlanAssigned');
  } else if (isComplete) {
    return `${t('Generic.planCompletedIn')} ${timeSpentOnPlan}`;
  } else if (!isCompliance) {
    return stepCount
      ? `${completedStepCount}/${stepCount} ${t(
          'Generic.itemsCompletedIn',
        )} ${timeSpentOnPlan}`
      : t('Generic.noContentInPlan');
  } else if (timeSpentOnPlan) {
    return `${percentComplete}% ${t('Generic.completedIn')} ${timeSpentOnPlan}`;
  } else {
    return `${percentComplete}% ${t('Generic.completed')}. ${t(
      'Generic.timeSpentNotAvailable',
    )}.`;
  }
};
